import { isSerializable } from '../types.js';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getNonFunctionProperties(instance, ignoreProperties) {
    return Object.keys(instance)
        .filter(key => isSerializable(instance[key]) && !ignoreProperties.includes(key))
        .reduce((obj, key) => {
        return { ...obj, [key]: instance[key] };
    }, {});
}
//# sourceMappingURL=getNonFunctionProperties.js.map